import _ from 'lodash'
import React from 'react'
import {number, any, shape, arrayOf} from 'prop-types'
import {Link, graphql} from 'gatsby'
import glamorous from 'glamorous'

import {mediaMaxWidth, sm} from '../css/themes'

import Default from '../layouts/default'
import MediaPreview from '../components/media-preview'
import {H2} from '../components/common'

const MediaPreviewWrapper = glamorous.div({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  [mediaMaxWidth(sm)]: {
    justifyContent: 'center',
  },
})

const renderMediaPreviews = edges => (
  <MediaPreviewWrapper>
    {_.map(edges, ({node: {frontmatter: {image, title, author, review}, fields: {path}}}) => {
      return (
        <MediaPreview key={title} title={title} author={author} review={review} path={path} image={image} />
      )
    })}
  </MediaPreviewWrapper>
)

const Reviews = ({location, data}) => (
  <Default title="Reviews" location={location}>
    <React.Fragment>
      <H2>📚 Books</H2>
      {renderMediaPreviews(data.books.edges)}
    </React.Fragment>

    <React.Fragment>
      <H2>🎙 Podcasts</H2>
      {renderMediaPreviews(data.podcasts.edges)}
    </React.Fragment>

    <React.Fragment>
      <H2>🎬 Films</H2>
      {renderMediaPreviews(data.films.edges)}
    </React.Fragment>
  </Default>
)

Reviews.propTypes = {
  data: shape({
    books: shape({
      edges: arrayOf(
        shape({
          node: any,
        })
      ),
    }).isRequired,
    podcasts: shape({
      edges: arrayOf(
        shape({
          node: any,
        })
      ),
    }).isRequired,
    films: shape({
      edges: arrayOf(
        shape({
          node: any,
        })
      ),
    }).isRequired,
  }).isRequired,
}

export default Reviews

export const pageQuery = graphql`
  query AllReviews {
    books: allMarkdownRemark(filter: {frontmatter: {type: {eq: "book"}}}) {
      edges {
        node {
          ...reviewAll
        }
      }
    }
    podcasts: allMarkdownRemark(filter: {frontmatter: {type: {eq: "podcast"}}}) {
      edges {
        node {
          ...reviewAll
        }
      }
    }
    films: allMarkdownRemark(filter: {frontmatter: {type: {eq: "film"}}}) {
      edges {
        node {
          ...reviewAll
        }
      }
    }
  }
`
